import React, { FunctionComponent, useMemo } from 'react';
import styled from 'styled-components';

import { DetailField, DetailFields } from '../../../components/basic/DetailFields';
import { useStateSelector } from '../../../data/global/dataSelectors';
import { UpdateMarketDataEntitlementBtn, UpdateMarketDataEntitlementBtnContexts } from '../../../components/entitlements/UpdateMarketDataEntitlementBtn';
import { firstSetOfMarketDataQuestionnaireBooleanFormFields, secondSetOfMarketDataQuestionnaireBooleanFormFields } from '@tradingblock/components';
import {
  FirstSetOfMarketDataQuestionnaireBooleanFormFields,
  MarketDataQuestionnaireYesNoQuestionsFromRequest,
  SecondSetOfMarketDataQuestionnaireBooleanFormFields
} from '@tradingblock/types';

const StyledDiv = styled.div`
  .error-msg {
    text-align: center;
  }

  .fields-title {
    width: max-content;
  }
`;

const MarketDataEntitlementSectionHeader: FunctionComponent<{}> = ({ children }) => {
  return (
    <span className="fields-title d-flex">
      <i className="fal fa-analytics dashboard-icon mr-1" />
      Market Data Entitlement
      {children}
    </span>
  );
};

export const MarketDataEntitlementSection: FunctionComponent<{}> = ({}) => {
  const accountManagementDetails = useStateSelector(s => s.accountManagement.accountManagementDetails.details);

  const fieldList: DetailField[] = useMemo((): DetailField[] => {
    if (accountManagementDetails) {
      const { marketData, marketDataType } = accountManagementDetails;
      const { questions } = marketData;

      // We are deleting the nonPersonalUse key because the backend still returns it but in order to match the question mapping we only want to keep the personalUse key.
      delete questions.nonPersonalUse;

      return [
        {
          Value: () => (
              <MarketDataEntitlementSectionHeader>
                <UpdateMarketDataEntitlementBtn
                  context={UpdateMarketDataEntitlementBtnContexts.preferences}
                  buttonText="(Update)"
                  marketDataEntitlementType={marketDataType && marketDataType.replace(/([A-Z])/g, ' $1').trim()}
                  buttonElementClassName="mute txt-sm"
                  buttonWrapperClassName="ml-1 d-flex align-items-center"
                />  
              </MarketDataEntitlementSectionHeader>
          ),
        },
        {
          Value: () => null,
        },
        {
          Value: () => (
            <>
              <span className="props-title">Entitlement Type</span>
              <br />
              <span className="mute">{(marketDataType && marketDataType.replace(/([A-Z])/g, ' $1').trim()) || ''}</span>
            </>
          )
        },
        {
          Value: () => null,
        },
        ...Object.keys(questions).map((questionsKey) => ({
          Value: () => (
            <>
              <span className="props-title">{firstSetOfMarketDataQuestionnaireBooleanFormFields[questionsKey as keyof FirstSetOfMarketDataQuestionnaireBooleanFormFields] || secondSetOfMarketDataQuestionnaireBooleanFormFields[questionsKey as keyof SecondSetOfMarketDataQuestionnaireBooleanFormFields]}</span>
              <br />
              <span className="mute">{questions[questionsKey as keyof MarketDataQuestionnaireYesNoQuestionsFromRequest] ? 'Yes' : 'No'}</span>
            </>
          )
        })),
      ];
    } else {
      return [];
    }
  }, [accountManagementDetails]);

  return (
    <StyledDiv className="screen-body-section">
      {
        accountManagementDetails ? 
        <DetailFields fieldList={fieldList} /> :
        (
          <>
            <DetailFields fieldList={[{Value: () => <MarketDataEntitlementSectionHeader />}]} />
            <p className="error-msg">There was an issue loading the data.</p>
          </>
        )
      }
    </StyledDiv>
  );
};
